<template>
  <el-dialog :visible.sync="dialogVisible" title="上传应用" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="390px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-upload
            :action="uploadFilesUrl"
            ref="upload"
            class="upload-apply"
            :show-file-list="true"
            :auto-upload="false"
            :limit="1"
            :accept=acceptFile
            :on-change="handleChange"
            :on-preview="handlePreview"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <el-button slot="trigger" size="small" type="primary">选择上传应用</el-button>
        </el-upload>

        <el-form-item label="文件类型">
            <el-radio-group v-model="form.fileType" @change="fileTypeChange">
                <el-radio :label="0">全量</el-radio>
                <el-radio :label="1">补丁</el-radio>
            </el-radio-group>
        </el-form-item> 
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button :loading="loading" type="primary" @click="save">保存</el-button>
      <el-button @click="dialogClose">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import http from '../../../../../common/http'

export default {
  name: 'createVersionForm',
  components: {  },
  props: {
    value: Boolean,
    applyId: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        fileType: 0
      },
      uploadFilesUrl: "",
      selectFileList: [], // 选择文件列表
      uploadFileList: [], // 上传文件列表
      rules: {
          applyVersion: [
              { required: true, message: '请输入应用版本', trigger: 'blur' }
          ],
          remark: [
              { required: true, message: '请输入更新功能', trigger: 'blur' }
          ]
      },
      acceptFile: ".deb,.exe"
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    },
  },
  created: function () {
  },
  methods: {
    dialogOpen() {
      console.log('applyId',this.applyId)

      // 值初始
      this.selectFileList = []
      this.uploadFileList = []
      this.acceptFile = ".deb,.exe"
      this.form.fileType = 0
    },
    fileTypeChange(value){
      console.log('fileTypeChange', value, typeof(value))
      if(value === 0){
        this.acceptFile = '.deb,.exe'
      }else if(value === 1){
        this.acceptFile = '.asar'
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {

           if(this.selectFileList.length == 0){
                this.$commonFn.showTip('应用为空，请上传', 3);
                return;
            }
            // 上传文件
            this.loading=true;
            this.$refs.upload.submit();
            // 延迟1秒执行
            setTimeout(this.uploadFile, 1000)
        }
      })
    },
    handleAvatarSuccess(res, file) {
      console.log('文件上传成功时的钩子触发')
    },
    handleExceed(files, fileList) {
      console.log('文件超出个数限制时的钩子触发')
    },
    beforeAvatarUpload(file) {
      let fileType = file.type
      let isLt2M = file.size / 1024 / 1024 < 200
      console.log("文件大小："+file.size)
      if (!isLt2M) {
          this.$commonFn.showTip('文件大小不能超过200MB!', 3)
          this.$refs.upload.clearFiles()
          return false
      }
      // .exe是全量文件，.asar是补丁文件
      let fileName=file.name
      //获取最后一个.的位置
      let index= fileName.lastIndexOf(".")
      //获取后缀
      let ext = fileName.substr(index+1)
      let fileObj={}
      fileObj.key=ext
      fileObj.val=file
      this.uploadFileList.push(fileObj)
    },
    handleRemove(file, fileList) {
      this.selectFileList = []
    },
    handlePreview(file) {
      console.log('点击文件列表中已上传的文件时的钩子触发');
    },
    handleChange(file, fileList){
      let fileType = file.type
      let isLt2M = file.size / 1024 / 1024 < 200
      console.log("文件大小："+file.size,"是否允许上传", isLt2M)
      if (!isLt2M) {
          this.$commonFn.showTip('文件大小不能超过200MB!', 3)
          this.$refs.upload.clearFiles()
          return false
      }

      let fileName=file.name
      // 获取扩展名
      let index= fileName.lastIndexOf(".")
      let ext = fileName.substr(index+1)

      // 全量
      if(this.form.fileType===0){
        if(ext == '' || ext == null){
          this.$commonFn.showTip('应用只支持扩展名（exe、deb）格式', 3)
          this.$refs.upload.clearFiles()
          return
        }
        if(ext.toLowerCase() != 'deb' && ext.toLowerCase() != 'exe'){
          this.$commonFn.showTip('应用只支持扩展名（exe、deb）格式', 3)
          this.$refs.upload.clearFiles()
          return
        }
      }else if(this.form.fileType===1){
        
        if(ext == '' || ext == null){
          this.$commonFn.showTip('应用只支持扩展名（asar）格式', 3)
          this.$refs.upload.clearFiles()
          return
        }
        if(ext.toLowerCase() != 'asar'){
          this.$commonFn.showTip('应用只支持扩展名（asar）格式', 3)
          this.$refs.upload.clearFiles()
          return
        }

      }

      this.selectFileList.push(file)
    },
    // 上传文件
    uploadFile(){
      console.log('文件个数',this.uploadFileList.length)
      let isHaveFile=false
      let file = undefined
      for(let i = 0; i < this.uploadFileList.length; i++) {
          let obj = this.uploadFileList[i]
          file = obj.val
          if('exe' === obj.key 
                || 'deb' === obj.key 
                    || 'asar' === obj.key){
              isHaveFile=true
              break
          }
      }

      if(!isHaveFile){
          this.$commonFn.showTip("应用不存在，请上传", 3)
          this.loading=false
          this.$refs.upload.clearFiles()
          return
      }
      console.log('file',file)
      let uploadForm=new FormData()
      uploadForm.append('file', file)
      uploadForm.append('applyId', this.applyId)

      console.log('上传文件...', uploadForm)
      // return;
      let uploadFilesUrl = this.thirdApplyFileUploadFullFileUrl
      if(this.form.fileType === 1){
        uploadFilesUrl = this.thirdApplyFileUploadPatchFileUrl
      }
      this.$axios.post(uploadFilesUrl, uploadForm,{
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then((res) => {
          console.log("文件反馈:"+JSON.stringify(res.data))
          if(res.data.status == 200){
              this.$commonFn.showTip(res.data.message,1)
              this.dialogVisible=false
              this.$emit('submit')
          }else{
              this.selectFileList=[]
              this.uploadFileList=[]
              this.$commonFn.showTip(res.data.message,3)
          }
          this.loading=false
      }, (err) => {
          console.log('上传失败',err)
          this.$commonFn.showTip("上传失败", 3)
          this.$refs.upload.clearFiles()
          this.loading=false
      })
    },
    dialogClose() {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/apply/thirdApply/components/uploadFile.vue